import {
  ButtonStyle,
  CarouselStyle,
  ImageUploadStyle,
  InputContainerStyle,
  SelectInputStyle,
} from 'components/Component.style';
import { IconView, PostBox } from 'pages/home/Home.style';
import { WaterMark } from 'pages/network/Network.style';
import styled from 'styled-components';

export const BusinessPlaceStyle = styled.div`
  padding-bottom: 70px;
  width: 100%;
  .category_list {
    margin-bottom: 8px;
    svg {
      fill: ${({ theme }) => theme.fieldBorder1};
    }
  }
  @media screen and (max-width: 599px) {
    .category_list {
      margin-bottom: 0px;
    }
  }
  .cardhr-div {
    position: relative;
    box-shadow: ${({ theme }) => theme.boxShadow1};
    border-radius: 8px;

    > div img {
      border-radius: 2px;
    }
    .card-in-div {
      position: relative;
      padding: 4px 8px 8px;
      color: ${({ theme }) => theme.text1};
      .company-link {
        color: #1976d2;
        svg {
          width: 18px;
          height: 18px;
          fill: #1976d2;
          position: relative;
          top: 5px;
        }
        &:hover {
          text-decoration: underline;
          cursor: pointer;
        }
      }

      .list-title {
        margin-top: 8px;
        height: 70px;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
      }

      p {
        margin: 3px 0px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }
    }
    .user-profile-img {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      object-fit: contain;
    }
    .list-date {
      position: absolute;
      right: 6px;
      top: 6px;
      color: #828282;
      font-size: 13px;
    }
  }
  .business-page-carousel {
    > div {
      &:nth-child(4) {
        display: none !important;
      }
    }
  }

  .post-apply {
    display: flex;
    align-items: center;
    height: auto;
    padding: 5px 7px;
  }
  .desc-hr {
    border-bottom: 1px solid #dbdbdb;
    margin-bottom: 3px;
    line-height: 2.2;
  }
  ${IconView} {
    padding: 0px 0px;
    margin-left: 5px;
    margin-top: 0px;
    .share-ic {
      transform: rotate(0deg);
      &:nth-child(1) {
        > svg {
          width: 20px;
        }
      }
    }
    .icon-title {
      margin-left: 0px;
    }
  }

  ${ButtonStyle} {
    max-height: 34px;
    font-size: 13px;
  }

  .search-container {
    display: flex;
    justify-content: space-between;
    button {
      font-size: 15px;
    }
    > div:first-child {
      width: 50%;
    }
    .add-business-fab {
      display: none;
    }
    .addbutton {
      path {
        fill: #fff;
      }
    }
  }
  ${ImageUploadStyle} {
    .dropzone-block .dropzoneContainer {
      min-height: 80px;
    }
  }
  .custom-popover {
    display: flex;
    align-items: center;
    justify-content: end;
    width: 100%;
    position: absolute;
    top: 4px;
    z-index: 677;
    right: 4px;
    svg {
      fill: ${({ theme }) => theme.tabText1};
    }
    button:hover {
      background-color: ${({ theme }) => theme.lightGrayHover} !important;
    }
  }
  ${CarouselStyle} {
    .cmy-carousel-list {
      > img {
        height: 100%;
        width: 100%;
        object-fit: contain;
      }
      height: 250px;
    }
  }
  .rating-container {
    text-align: center;
    margin-top: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .detailIcon {
      width: 17px;
      height: 17px;
      g {
        fill: #828282;
      }
    }
  }
  .status-context {
    font-size: 15px;
    font-weight: 700;
    .approved {
      color: #08979c;
    }
    .rejected {
      color: red;
    }
    .pending {
      color: #8e8e1e;
    }
  }
  .rating-star {
    display: flex;
    align-items: center;
    padding: 0 2px;
    .overall-rating {
      margin-left: 12px;
    }
    &:hover {
      background-color: ${({ theme }) => theme.lightGrayHover};
      border-radius: 2px;
      cursor: pointer;
    }
    .MuiRating-icon.MuiRating-iconEmpty {
      svg path {
        fill: ${({ theme }) => theme.svg2};
      }
    }
  }
  .Profile-Business-VirtuosoGrid {
    .virtuoso-grid-list {
      > div {
        width: 49% !important;
      }
    }
  }
  .Business-VirtuosoGrid {
    .virtuoso-grid-list {
      > div {
        width: 32%;
      }
      @media only screen and (max-width: 949px) {
        > div {
          width: 48.5%;
        }
      }
      @media only screen and (max-width: 650px) {
        > div {
          width: 100%;
        }
      }
    }
  }
  .virtuoso-grid-list {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 10px;
    // > div {
    //   width: 32%;
    // }
    @media only screen and (max-width: 949px) {
      > div {
        width: 48.5%;
      }
    }
    @media only screen and (max-width: 500px) {
      > div {
        width: 100%;
      }
    }
  }
  ${WaterMark} {
    height: 250px;
    .business-watermark-text {
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      width: 80px;
      position: absolute;
      font-size: 14px;
      color: ${({ theme }) => theme.mode === 'light' ? '#00000014' : '#6b6b6b61'};
      pointer-events: none;
      transform: rotate(-30deg);

      &:nth-child(1) {
        top: 50px;
        left: 6%;
      }
      &:nth-child(2) {
        top: 150px;
        left: 6%;
      }
      &:nth-child(3) {
        top: 50px;
        left: 38%;
      }
      &:nth-child(4) {
        top: 150px;
        left: 38%;
      }
      &:nth-child(5) {
        top: 50px;
        left: 73%;
      }
      &:nth-child(6) {
        top: 150px;
        left: 73%;
      }
    }
  }
  @media only screen and (max-width: 600px) {
    .search-container {
      margin: 0 12px;
      > div:first-child {
        width: 90%;
        margin-right: 6px;
      }
      .add-business {
        display: none;
      }
      .add-business-fab {
        display: flex;
        box-shadow: none;
        width: 36px;
        height: 36px;
        background-color: #2d90ff;
        z-index: 1;
        svg {
          fill: #fff;
        }
      }
    }
  }
`;

export const PostedUserDetails = styled.div`
  &.posted-user-details {
    margin-bottom: 20px;
    .posted-user-container {
      max-width: 400px;
      padding: 6px;
    }
    .posted-user-img {
      width: 45px;
      height: 45px;
      img,
      svg {
        width: 45px;
        height: 45px;
        border-radius: 50%;
        path {
          fill: ${({ theme }) => theme.svg2};
        }
      }
    }
    .posted-username-details {
      margin-left: 6px;
    }
    .user-action {
      &:hover {
        cursor: pointer;
        text-decoration: underline;
      }
    }
  }
  .posted-user-title {
    font-size: 14px;
    color: #828282;
  }
  .posted-user-container {
    display: flex;
    align-items: center;
    border: 1px solid ${({ theme }) => theme.lightGray};
    border-radius: 50px;
    padding: 4px;
    max-width: 100%;
  }
  .posted-user-container-width {
    padding-right: 10px;
    width: fit-content;
  }
  .posted-user-img {
    width: 40px;
    height: 40px;
    img {
      width: 40px;
      height: 40px;
    }
    img,
    svg {
      path {
        fill: ${({ theme }) => theme.svg2};
      }
    }
  }
  .user-profile-img {
    border-radius: 50%;
  }
  .posted-username-details {
    margin-left: 4px;
    font-size: 14px;
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: ${({ theme }) => theme.text1};
    display: flex;
    flex-wrap: wrap;
  }
  .posted-name-container {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
  }
  .posted-username {
    font-size: 13px;
    color: #828282;
  }
  .posted-headline {
    font-size: 14px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
  }
`;

export const BusinessList = styled.div`
  @media screen and (max-width: 599px) {
    padding: 8px;
  }
`;

export const LoaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 30vh;
`;

export const AddBuinessPlaceStyle = styled.div`
  color: ${({ theme }) => theme.text1};
  label {
    cursor: auto;
  }
  .field-flex {
    display: flex;
    justify-content: space-between;
    > div {
      width: 49%;
    }
  }
  .location-title {
    margin-bottom: 8px;
  }
  .worldwide-checkbox {
    & ~ span {
      font-size: 15px;
    }
  }
  .location-or {
    display: flex;
    margin: 8px 0;
    > div {
      width: 200px;
      color: #828282;
      font-size: 14px;
    }
  }
  .business-hub-titles {
    padding: 8px 0;
    .company-link {
      color: #1976d2;
      &:hover {
        text-decoration: underline;
        cursor: pointer;
      }
    }
  }
  .detail-view {
    display: flex;
    flex-direction: column;
    .description-section {
      margin-bottom: 8px;
      margin-top: 4px;
      word-break: break-all;
    }
    > label:nth-child(1) {
      font-size: 18px;
      font-weight: 600;
      margin-top: 12px;
    }
    .MuiChip-root {
      margin-right: 6px;
      margin-bottom: 4px;
    }
  }
  .business-contact-details {
    margin-bottom: 20px;
  }
  .grid-sec1 {
    grid-template-columns: minmax(0px, auto) minmax(0px, auto);
    grid-template-areas:
      'sidebar main'
      '. aside';
    display: grid;
    ${InputContainerStyle}:nth-child(odd),${SelectInputStyle}:nth-child(odd) {
      padding-right: 20px;
    }
  }
  .InputContainerStyle {
    margin-bottom: 10px;
  }
  .cancel-btn {
    background: #fff;
    border: 1px solid #097bed;
    color: #097bed;
    margin-left: 15px;
    cursor: pointer;
  }
  .btn_conts {
    text-align: end;
    padding: 10px 20px 10px 0px;
    > button:nth-child(1) {
      margin-right: 15px;
    }
  }

  .post-back {
    font-weight: 600;
    font-size: 19px;
    margin-bottom: 12px;
    margin-left: 4px;
    z-index: 99;
    .close-icon-container {
      margin: 0 13px 0px 0px;
    }
  }
  .add-flex {
    display: grid;
    grid-template-columns: 43% 43% 10.1%;
    align-items: center;
    gap: 12px;
    .InputContainerStyle {
      margin-bottom: 0px;
    }
    ${ButtonStyle} {
      position: relative;
      top: 14px;
    }
  }
  .modal-footer {
    display: flex;
    align-items: end;
    justify-content: end;
    margin-top: 20px;
  }
  .job-chip-container {
    .MuiButtonBase-root {
      margin: 5px 5px;
    }
  }
  ${PostBox} {
    padding: 8px 8px 4px;
  }
  &:nth-child(1) ${PostBox} {
    margin-bottom: 16px;
  }
  .Business-update-modal {
    .MuiDialog-container {
      .MuiPaper-root-MuiDialog-paper {
        width: 600px;
      }
    }
  }
  .editdiv {
    display: flex;
  }
  .city-div {
    display: grid;
    grid-template-columns: 100% 20px;
    align-items: center;
    gap: 10px;
  }
  @media only screen and (max-width: 565px) {
    .add-flex {
      display: block;
      ${InputContainerStyle}:nth-child(2) {
        .MuiFormControl-root {
        }
      }
    }
    .btn_conts {
      margin-bottom: 20px;
    }

    .city-div {
      display: grid;
      align-items: center;
      grid-template-columns: 75% 10px;
      gap: 10px;
    }
  }
  .action-container {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    margin-top: 8px;
    min-height: 35px;
    white-space: nowrap;
    hr {
      margin: 0 2%;
      height: 22px;
      margin-top: 7px;
    }
  }
  .business-hub-detail-actions {
    display: flex;
  }
  .business-more-btn {
    position: absolute;
    right: 10px;
  }
  .rating-star {
    display: flex;
    align-items: center;
    padding: 0 2px;
    .overall-rating {
      margin-left: 12px;
    }
    &:hover {
      background-color: ${({ theme }) => theme.lightGrayHover};
      border-radius: 2px;
      cursor: pointer;
      width: max-content;
    }
    .MuiRating-icon.MuiRating-iconEmpty {
      svg path {
        fill: ${({ theme }) => theme.svg2};
      }
    }
  }
  .add-more-section {
    path {
      fill: #1976d2;
    }
  }
  @media only screen and (max-width: 500px) {
    .card-in-div-parent {
      width: 100%;
    }
  }
  .updates-header {
    margin-bottom: 4px;
  }
  .business-detail-view {
    background-color: ${({ theme }) => theme.mode === "light" ? theme.tabBg1 : theme.modalBg1};
    border-radius: 6px;
    margin-bottom: 80px;
  }
  @media only screen and (max-width: 670px) {
    .updates-header {
      margin: 8px;
    }
    .business-detail-view {
      margin: 8px;
      background-color: transparent;
    }
  }
`;

export const RatingsContainer = styled.div`
  .user-ratings {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .table-no-border {
    width: 70%;
    th {
      font-size: 16px;
      font-weight: 500;
    }
    td {
      text-align: center;
    }
    .MuiRating-root {
      font-size: 30px;
    }
    .total-stars {
      font-size: 20px;
    }
  }
  .MuiRating-icon.MuiRating-iconEmpty {
    svg path {
      fill: ${({ theme }) => theme.svg2};
    }
  }
  .rating-action-container {
    display: grid;
    align-items: center;
    justify-content: center;
    margin-top: 24px;
    .MuiRating-root {
      font-size: 32px;
    }
    .rating-action {
      margin-top: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .rating-action-text {
      font-size: 24px;
      margin-left: 20px;
    }
    .rating-submit {
      margin-top: 8px;
    }
  }
`;

export const BusinessUpdateList = styled.div`
  padding-top: 16px;
  display: flex;
  justify-content: center;
  .update-item-container {
    width: 100%;
    max-width: 600px;
  }
  .card-container {
    box-shadow: ${({ theme }) => theme.boxShadow1};
    border-radius: 4px;
    background-color: ${({ theme }) => theme.Bg1};
  }
  .update-content {
    position: relative;
    padding: 8px;
    .image-div-parent {
      display: flex;
      align-items: center;
      justify-content: center;
      min-height: 100px;
      background-color: ${({ theme }) => theme.mode === "light" ? theme.tabBg1 : theme.modalBg1};
    }
    img {
      max-width: 100%;
      max-height: 400px;
      border-radius: 2px;
    }
    .title {
      font-weight: 600;
      margin: 8px 0;
    }
  }
  .updates-date {
    position: absolute;
    right: 14px;
    top: 20px;
    color: #828282;
    font-size: 12px;
    background-color: ${({ theme }) => theme.Bg1};
    border-radius: 12px;
    padding: 0 6px;
  }
  .likesdiv {
    cursor: pointer;
    > button span {
      display: flex;
    }
    .business-thumb-down {
      margin-left: 8px;
    }
    svg {
      fill: #828282;
    }
    span {
      color: #828282;
      font-size: 14px;
    }
    .activelike svg {
      fill: #ec6a8f;
    }
  }
  .card-footer-div {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 6px 0;
    border-top: 1px solid rgba(0, 0, 0, 0.12);
    margin: auto 8px;
    .edit-icon {
      cursor: pointer;
      > button {
        fill: #828282;
      }
    }
    .remove-icon {
      cursor: pointer;
      > button {
        fill: red;
      }
    }
  }
  .arrow-container {
    display: flex;
    justify-content: center;
    margin-top: 8px;
    svg path {
      fill: #828282;
    }
  }
`;
